import { Navigate, Route, Routes } from 'react-router-dom'
import { useRoutes } from './hooks/useRoutes'
import { Suspense, useMemo } from 'react'
import ErrorBoundary from './components/ErrorBoundary'
import NotFound from './components/NotFound'
import NoAccess from './components/NoAccess'
import Wrapper from './pages/Wrapper'
import { DASHBOARD_ENDPOINT } from './utils/Endpoints'
import Loader from './components/Loader'

const Navigation = () => {
  const appRoutes = useRoutes()

  const enabledRoutes = useMemo(
    () => appRoutes?.filter((route) => route?.enabled),
    [appRoutes]
  )

  return (
    <ErrorBoundary>
      <Suspense fallback={<Loader />}>
        <Routes>
          {/* Auth Routes */}
          {/* <Route path={SIGNIN_ENDPOINT} element={<SignIn />} />
          <Route path={SIGNUP_ENDPOINT} element={<Signup />} /> */}

          {/* Default redirect */}
          <Route
            path='/'
            element={<Navigate to={DASHBOARD_ENDPOINT} replace />}
          />

          {/* App Routes (with Wrapper layout inside each) */}
          <Route element={<Wrapper />}>
            {enabledRoutes?.map((route) => (
              <Route
                key={route?.key}
                path={route?.path}
                element={
                  <Suspense fallback={<Loader />}>
                    <route.component />
                  </Suspense>
                }
              >
                {route?.children
                  ?.filter((child) => child?.enabled)
                  ?.map((child) => (
                    <Route
                      key={child?.key}
                      path={child?.path}
                      element={
                        <Suspense fallback={<Loader />}>
                          <child.component />
                        </Suspense>
                      }
                    />
                  ))}
              </Route>
            ))}
          </Route>

          {/* Catch-all 404 route */}
          <Route
            path='*'
            element={enabledRoutes?.length === 0 ? <NoAccess /> : <NotFound />}
          />
        </Routes>
      </Suspense>
    </ErrorBoundary>
  )
}

export default Navigation

/* Control Flow: index -> App -> Navigator*/
